export class Contact {
    public emailFrom: String;
    public name: String;
    public phone: String;
    public message: String;
    public subject: String;
}
